import { render, staticRenderFns } from "./Q&A.vue?vue&type=template&id=734ca054&scoped=true&"
import script from "./Q&A.vue?vue&type=script&lang=js&"
export * from "./Q&A.vue?vue&type=script&lang=js&"
import style0 from "./Q&A.vue?vue&type=style&index=0&id=734ca054&lang=less&scoped=true&"
import style1 from "./Q&A.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734ca054",
  null
  
)

export default component.exports